import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const getHighlightedText = (text, searchTerm) => {
  if (text === searchTerm) return /*#__PURE__*/_jsx("span", {
    className: "rgt-search-highlight",
    children: text
  });
  const regex = new RegExp(searchTerm, 'gi');
  const restArr = text.split(regex, text.length);
  let restItemsLength = 0;
  const highlightedSearch = restArr.map((textSlice, idx) => {
    restItemsLength += textSlice.length;
    let element = null;

    if (textSlice) {
      element = /*#__PURE__*/_jsxs(React.Fragment, {
        children: [/*#__PURE__*/_jsx("span", {
          children: textSlice
        }), restArr.length !== idx + 1 ? /*#__PURE__*/_jsx("span", {
          className: "rgt-search-highlight",
          children: text.slice(restItemsLength, searchTerm.length + restItemsLength)
        }) : null]
      }, idx);
    } else if (restArr.length !== idx + 1) {
      element = /*#__PURE__*/_jsx("span", {
        className: "rgt-search-highlight",
        children: text.slice(restItemsLength, searchTerm.length + restItemsLength)
      }, idx);
    }

    restItemsLength += searchTerm.length;
    return element;
  });
  return /*#__PURE__*/_jsx("span", {
    children: highlightedSearch
  });
};

export default getHighlightedText;